<template>
  <div :class="classes" v-on="$listeners" v-bind="$attrs">
    <div class="am-alert-content">
      <!-- @slot Alert Content -->
      <slot />
    </div>
    <div class="am-alert-actions" v-if="$slots.actions">
      <!-- @slot Actions slot -->
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import { enumValidator } from "../enumValidator";

export default {
  inheritAttrs: false,
  props: {
    /**
     * ["primary", "positive", "negative", "warning", "dark"]
     */
    color: {
      type: String,
      validator: enumValidator(["primary", "positive", "negative", "warning", "dark"]),
      default: "primary"
    }
  },
  computed: {
    classes() {
      return ["am-alert", `am-alert--color-${this.color}`];
    }
  }
};
</script>
